import { connect } from 'react-redux';

import DetailedSearchView from './DetailedSearchView.jsx';

import { searchAsset, searchGroups, searchStreams, fetchTags, invalidateAssetSearchResult,
  invalidateGroupsSearchResult, invalidateStreamsSearchResult, invalidateTags, 
  recordSearchQuery
} from 'src/legacy/redux/actions/search.jsx';
import {invalidateSeekSession} from "src/redux/actions/seek";

import {trackAdoptionMetricsForContentSearchEvent} from "src/legacy/redux/actions/adoption";
import { fetchCustomFields } from 'src/legacy/redux/actions/customFields.jsx';
import { fetchStream } from 'src/legacy/redux/actions/streams';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  var entityType = ownProps.params.page;
 
  var entity = state.legacyRootReducer.search[entityType];

  var id = ownProps.params.id;
  var streamState = state.legacyRootReducer.stream[id];
  var stream = streamState ? streamState.item : null;

  const searchableFields = (state.legacyRootReducer.settings.customFields.items || []).filter(field => {
    return field.searchable;
  });

  return {
    account: _.get(state, "accounts.item", {}),
    stream: stream ,
    entityType: entityType,
    entity: entity,
    searching: entity.searching,
    tags: state.legacyRootReducer.search.tags.item,
    totalItems: state.legacyRootReducer.search.tags.totalItems,
    fetchingTag: state.legacyRootReducer.search.tags.loading,
    customFields: searchableFields,
    isCustomFieldsLoading: _.get(state,"legacyRootReducer.settings.customFields.loading", false),
    isCustomFieldsFetched: _.get(state,"legacyRootReducer.settings.customFields.isFetched", false),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    searchAsset: (query, filter, page, limit, highlight, searchWithinHub) => {
      return dispatch(searchAsset(query, filter, page, limit, highlight, searchWithinHub));
    },
    searchGroups: (query, filter, page, limit, highlight) => {
      return dispatch(searchGroups(query, filter, page, limit, highlight));
    },
    searchStreams: (query, filter, page, limit, highlight) => {
      return dispatch(searchStreams(query, filter, page, limit, highlight));
    },
    fetchTags: (query, filter) => {
      return dispatch(fetchTags(query, filter));
    },
    fetchCustomFields: () => {
      return dispatch(fetchCustomFields());
    },
    invalidateAssetSearchResult: () => {
      return dispatch(invalidateAssetSearchResult());
    },
    invalidateGroupsSearchResult: () => {
      return dispatch(invalidateGroupsSearchResult());
    },
    invalidateStreamsSearchResult: () => {
      return dispatch(invalidateStreamsSearchResult());
    },
    invalidateTags: () => {
      return dispatch(invalidateTags())
    },
    recordSearchQuery: (context) => {
      return dispatch(recordSearchQuery(context));
    },
    invalidateSeekSession: () => {
      return dispatch(invalidateSeekSession());
    },
    fetchStream: (id) => {
      return dispatch(fetchStream(id));
    },
    trackAdoptionMetricsForContentSearchEvent: (sourceCta, searchString, filter, tags, categories) => {
      return dispatch(trackAdoptionMetricsForContentSearchEvent(sourceCta, searchString, filter, tags, categories));
    },
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    search: (entityType, query, filter, page, limit, highlight, searchWithinHub) => {
      if(entityType == 'assets'){
        dispatchProps.searchAsset(query, filter, page, limit, highlight, searchWithinHub);
      }else if(entityType == 'groups'){
        dispatchProps.searchGroups(query, filter, page, limit, highlight);
      }else if(entityType == 'streams'){
        dispatchProps.searchStreams(query, filter, page, limit, highlight);
      }
    }
  })
}

const DetailedSearchPage = connect (
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(DetailedSearchView);

export default withUseHooks(DetailedSearchPage)

